import { DefaultSidebar } from "@excalidraw/excalidraw";

import "./AppSidebar.scss";

/** Sidebar tabs are reserved for future diagrams.free features. */
export const AppSidebar = () => {
  return <DefaultSidebar>{null}</DefaultSidebar>;
};
